import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  fetchAlltrainingtype,
  createTrainingType,
  updatetrainingtype,
  deletetrainingtypeById,
  gettrainingtypeById,
} from "../data/redux/training/trainertype/trainertypeAction";
import { Drawer, message } from "antd";

interface TrainingTypeModalProps {
  visible: boolean;
  onClose: () => void;
}

const TrainingTypeModal: React.FC<TrainingTypeModalProps> = ({
  visible,
  onClose,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const terminationId = selectedRowData?.Id;
  const { trainingType ,loading} = useSelector((state: any) => state.training.trainingType);
  const [errors, setErrors] = useState<any>({});
  const { user } = useSelector((state: any) => state.auth);
  const statusOptions = [
    { value: "Select", label: "Select" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const [formData, setFormData] = useState<any>({
    name: "",
    description: "",
    status: statusOptions[1],
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      status: selectedOption,
    });
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {
      Name: "",
      Description: "",
      Status: "",
    };

    if (!formData.name.trim()) {
      formIsValid = false;
      newErrors.Name = "Name is required.";
    }

   
    

    if (!formData.status || formData.status.value === "Select") {
      formIsValid = false;
      newErrors.Status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      ...formData,
      status: formData.status.value,
      createdBy: user.UserId,
    };

    dispatch(createTrainingType(payload))
      .then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success("Training Type Created Successfully");
          setFormData({
            name: "",
            description: "",
            status: statusOptions[1],
          });
          dispatch(fetchAlltrainingtype());
          onClose()
        } else {
          message.error(res.payload.message);
        }
      })
      .catch((error: any) => {});
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
    setFormData({
      employee: record.Resigning_Employee || "",
      terminationType: record.Termination_Type || "",
      noticeDate: record.Notice_Date ? record.Notice_Date.split("T")[0] : "",
      reason: record.Reason || "",
      resignationDate: record.Resignation_Date
        ? record.Resignation_Date.split("T")[0]
        : "",
    });
  };

  useEffect(() => {
    dispatch(fetchAlltrainingtype());
  }, []);

  return (
    <>
      <Drawer
        title="Add Training Type"
        placement="right"
        onClose={onClose}
        open={visible}
        width={480}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.Name && (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={statusOptions}
                    value={formData.status}
                    onChange={handleSelectChange}
                  />
                  {errors.Status && (
                    <div style={{ color: "red", marginTop: 4 }}>
                      {errors.Status}
                    </div>
                  )}
                </div>
              </div>
               <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <textarea
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {errors.Description && (
                    <div style={{ color: "red" }}>{errors.Description}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={onClose}
            >
              Cancel
            </button>
                      <button
                         type="submit"
                         className="btn btn-primary"
                         disabled={loading}
                          >
                         {loading ? (
                         <><span className="spinner-border spinner-border-sm me-2"role="status"
                         aria-hidden="true"  ></span>Add...</>) : ('Add Training'
                         )}
                      </button>
          </div>
        </form>
      </Drawer>
    </>
  );
};

export default TrainingTypeModal;
